


















import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteButton from '@/components/VoteButton.vue';
import { detail } from '@/api/api.ts';
import { videoPlay } from './api';
import * as config from './config';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo } from '@/common/ts/common';
import SyPlayer from '@/components/SyPlayer.vue';
import { Col } from 'vant';
@Component({
  name: 'DetailPage',
  components: {
    VoteButton,
    SyPlayer,
  },
})
export default class DetailPage extends Vue {
  detailData: any = {};
  dp: any = null;
  dd: any = null;
  focus = false;
  paused = true;
  timer: any = null;
  option: any = config.OPTHINES;

  created() {
    this.option.voteName = '2020project/2020sportman';
    detail(config.OPTHINES.voteName, this.$route.query.id).then((res) => {
      this.detailData = res.data;
    });
    autoOpenApp();
    // 分享
    appShare({
      title: '重庆体彩特约上游运动家短视频挑战赛',
      url: window.location.href,
      subtitle: '重庆体彩特约上游运动家短视频挑战赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '重庆体彩特约上游运动家短视频挑战赛',
      subtitle: '重庆体彩特约上游运动家短视频挑战赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  votSuccess() {
    console.log('success');
    detail(config.OPTHINES.voteName, this.$route.query.id).then((res) => {
        this.detailData.votes = res.data.votes;
      });
  }
  countVideoPlay() {
    // clearTimeout(this.timer);
    this.dd = this.$refs.dp;
    console.log(this.dd.dp);
    const videoOver = Number(this.dd.dp.video.duration) - Number(this.dd.dp.video.currentTime);
    if (this.dd.dp.focus && (videoOver === Number(this.dd.dp.video.duration))) {
      videoPlay(this.detailData.id).then((res) => {
        this.detailData.play_num = res.data;
      });
    }
  }
  destroyed() {
    (document.querySelector('body') as HTMLBodyElement).classList.remove(
      'dplayer-web-fullscreen-fix',
    );
  }
}
